'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// styled


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Parser = require('../Parser');

var _Parser2 = _interopRequireDefault(_Parser);

var _Form = require('../Observables/Form');

var _Form2 = _interopRequireDefault(_Form);

var _validationMessage = require('./styled/validation-message');

var _validationMessage2 = _interopRequireDefault(_validationMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RuleHint = (_dec = (0, _mobxReact.inject)('formStore'), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(RuleHint, _Component);

  function RuleHint() {
    (0, _classCallCheck3.default)(this, RuleHint);
    return (0, _possibleConstructorReturn3.default)(this, (RuleHint.__proto__ || (0, _getPrototypeOf2.default)(RuleHint)).apply(this, arguments));
  }

  (0, _createClass3.default)(RuleHint, [{
    key: 'getHint',
    value: function getHint() {
      var tokens = this.props.tokens;

      var hint = this.props.hint;
      (0, _keys2.default)(tokens).forEach(function (token) {
        hint = hint.replace(new RegExp('{{' + token + '}}', 'g'), tokens[token]);
      });

      return hint;
    }
  }, {
    key: 'render',
    value: function render() {
      var hint = this.getHint();
      var RuleComponent = _validationMessage2.default.withComponent(this.props.component.type || this.props.component);
      return _react2.default.createElement(
        RuleComponent,
        { className: 'hrw-validation-message' },
        _react2.default.createElement(
          'span',
          null,
          (0, _Parser2.default)((0, _Parser.template)(this.props.formStore, hint))
        )
      );
    }
  }]);
  return RuleHint;
}(_react.Component), _class2.propTypes = {
  hint: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]).isRequired,
  tokens: _propTypes2.default.objectOf(_propTypes2.default.node),
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    type: _propTypes2.default.string.isRequired,
    props: _propTypes2.default.shape({
      className: _propTypes2.default.string
    })
  }), _propTypes2.default.node]),
  formStore: _propTypes2.default.instanceOf(_Form2.default).isRequired
}, _class2.defaultProps = {
  tokens: {},
  tokenCharacter: ':',
  component: 'li'
}, _temp)) || _class);
exports.default = RuleHint;